// @flow
import _ from 'lodash'
import GoogleMapPoint from './google.map.point'

const DEFAULT_RADIUS = 3
const defaultZoom = 6
const focusZoom = 10
const moscowCoords = { lat: 55.751632, lng: 37.618707 }

export type Point = {|
  latitude: number,
  longitude: number,
  radius: number,
  name: string
|}

export default class GoogleMap {
  googleMap: any
  container: any

  pts: Array<GoogleMapPoint> = []
  onPointAddFuncs: Array<(GoogleMapPoint) => void> = []

  constructor(container: any) {
    this.container = container

    this.googleMap = new window.google.maps.Map(this.container[0], {
      center: moscowCoords,
      zoom: defaultZoom,
      mapTypeControl: false,
      scaleControl: true,
      zoomControl: true,
      streetViewControl: false,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    })

    window.google.maps.event.addListener(this.googleMap, 'click', (e) => {
      this.addPoint({
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng(),
        radius: DEFAULT_RADIUS,
        name: ''
      })
    })
  }

  focus() {
    setTimeout(() => {
      window.google.maps.event.trigger(this.googleMap, 'resize')
      this.googleMap.setCenter(this.averagePointCenter())
      this.googleMap.setZoom(defaultZoom)
    }, 100)
  }

  focusOn(longitude: number, latitude: number) {
    this.googleMap.setZoom(focusZoom)
    this.googleMap.panTo({
      lat: latitude,
      lng: longitude
    })
  }

  pointsData(): Array<Point> {
    return _.map(this.pts, (point) => point.data())
  }

  points() {
    return this.pts
  }

  pointsCount() {
    return this.pts.length
  }

  averagePointCenter() {
    let points = this.pointsData()
    if (points.length === 0) {
      return moscowCoords
    } else {
      return new window.google.maps.LatLng(
        _.sum(_.map(points, 'latitude')) / points.length,
        _.sum(_.map(points, 'longitude')) / points.length
      )
    }
  }

  onPointAdd(func: (GoogleMapPoint) => void) {
    return this.onPointAddFuncs.push(func)
  }

  addPoint(pointData: Point) {
    let point = new GoogleMapPoint(
      this.googleMap,
      pointData.longitude,
      pointData.latitude,
      pointData.radius,
      pointData.name
    )
    this.pts.push(point)
    _.each(this.onPointAddFuncs, (func) => func(point))
    return point
  }

  removePoint(point: GoogleMapPoint) {
    this.pts = _.reject(this.pts, (pt) => pt === point)
    point.eraseFromMap()
  }

  clearAll() {
    _.each(this.pts, (pt) => pt.eraseFromMap())
    this.pts = []
  }
}

export type { GoogleMap }
